import Axios from '../../../config/axios-nextgen';

/**
 * Audit API service (next gen).
 *
 * The old-gen /api/GetAuditSearchResults endpoint returns every matching row with no
 * paging - on a 6M row Auditing table that reliably times out. The next-gen endpoint
 * pages server-side and exposes a separate export route that re-runs the query rather
 * than having the client post rows back, so this screen talks to that instead.
 *
 * These deliberately do NOT swallow errors into a resolved `undefined` the way the
 * old-gen AuditService does - callers need the rejection so a failed search can show a
 * message instead of feeding undefined into the table.
 */

/**
 * @param {object} searchParams - eventTime/examTime/resultTime ranges, selectedEventTypes,
 *                                selectedUsers, selectedFacilities, mrn
 * @param {number} page - 1-based
 * @param {number} pageSize
 * @returns {Promise<{data: Array, pagination: {currentPage, pageSize, totalRecords, totalPages, hasPreviousPage, hasNextPage}}>}
 */
export function getAuditSearchResults(searchParams, page = 1, pageSize = 10) {
    return Axios.post('/api/auditing/audit-search', searchParams, { params: { page, pageSize } })
        .then(response => response.data);
}

/**
 * Re-runs the same search unpaged and returns the flattened export rows
 * (eventTime, userName, eventType, mrn, examDateTime, resultDate).
 * @param {object} searchParams - same shape as getAuditSearchResults
 * @returns {Promise<Array>}
 */
export function getAuditSearchExport(searchParams) {
    return Axios.post('/api/auditing/audit-search-export', searchParams)
        .then(response => response.data);
}

const auditService = {
    getAuditSearchResults,
    getAuditSearchExport
};

export default auditService;
